<template>
  <Container class="pl-0  pt-6 w-full bg-white">
    <PageHeading :title="$t('layouts.manufacturers.device_revision_firmware_management')"/>

    <ManufacturersSelectDeviceRevision/>
  </Container>

  <TabLayout :tabs="tabs" sticky>
    <main class="flex-1 overflow-auto">
      <router-view></router-view>
    </main>
  </TabLayout>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";
import ManufacturersSelectDeviceRevision from "@/Pages/Manufacturers/ManufacturersSelectDeviceRevision.vue";

export default {
  name: "ManufacturersLayout",
  components: {ManufacturersSelectDeviceRevision, Container, PageHeading, TabLayout},
  methods: {},
  computed: {
    tabs() {
      const revision = this.$route.params.revision;
      const manufacturer = this.$route.params.manufacturer;

      if (!revision || !manufacturer)
        return [];

      return [
        {
          label: this.$t('layouts.manufacturers.dashboard'),
          to: {name: 'manufacturers.dashboard'},
          current: this.$route.name === 'manufacturers.dashboard'
        },
        {
          label: this.$t('layouts.manufacturers.firmware_overrides'),
          to: {name: 'manufacturers.overrides'},
          current: this.$route.name === 'manufacturers.overrides'
        }
      ].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission));
    },
  },
}
</script>

<style scoped>

</style>
